import { FormResponse } from "@archetypes/responses";
import { removeHTMLTagsAndCharacterEntities } from "./generic.util";
import { replaceMentionTagsWithTokenString } from "./formula.util";
import { ElementType, FormValue, PRECISION, Question } from "@archetypes/form";
import { mathlib } from "@constants/math";

export const isValidMathExpression = (
  expression: string,
  keys: string[],
  questionsMap: Record<string, Question>,
) => {
  const tokenString = "question_";
  const scope: Record<string, number | Date> = {};
  const cleanExpression = removeHTMLTagsAndCharacterEntities(
    replaceMentionTagsWithTokenString(expression, tokenString),
  );
  keys.forEach((id) => {
    if (questionsMap[id]?.type === ElementType.DatePicker) {
      scope[tokenString + id] = new Date();
    } else {
      scope[tokenString + id] = 0;
    }
  });
  try {
    mathlib.evaluate(cleanExpression, scope);
    return true;
  } catch {
    return false;
  }
};

export const evaluateMathExpression = ({
  expression,
  precision,
  formValues,
  keys,
  unit,
}: {
  expression: string;
  precision: PRECISION;
  formValues: FormResponse;
  keys: string[];
  unit?: string;
}) => {
  const tokenString = "question_";
  const cleanExpression = removeHTMLTagsAndCharacterEntities(
    replaceMentionTagsWithTokenString(expression, tokenString),
  );
  const scope: Record<string, FormValue> = {};
  keys.forEach((id) => {
    const value = formValues[id];
    scope[tokenString + id] = value as FormValue;
  });
  try {
    const result = mathlib.evaluate(cleanExpression, scope);

    if (typeof result === "string") {
      return result;
    } else if (typeof result === "number") {
      return Number(result.toFixed(precision)) + (unit || "");
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`Error evaluating expression: ${cleanExpression}`, err);
    return null;
  }
};
